import { render, staticRenderFns } from "./ViewChannelPartnerCustomerAgreementsPopUp.vue?vue&type=template&id=1bb96b5e&scoped=true"
import script from "./ViewChannelPartnerCustomerAgreementsPopUp.vue?vue&type=script&lang=js"
export * from "./ViewChannelPartnerCustomerAgreementsPopUp.vue?vue&type=script&lang=js"
import style0 from "./ViewChannelPartnerCustomerAgreementsPopUp.vue?vue&type=style&index=0&id=1bb96b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb96b5e",
  null
  
)

export default component.exports